import $ from 'jquery'
import IMask from 'imask'

class Module {
  constructor ($module) {
    this.$module = $module
    this.$wallets = $module.find('#sape_withdrawal_financialAccount')
    this.$walletsSelector = $module.find('.sape_withdrawal_financialAccount')
    this.$amount = $module.find('#sape_withdrawal_amount')

    this.bind()
  }

  bind () {
    const self = this
    const maskedAmount = new IMask(this.$amount[0], {
      mask: Number,
      scale: 2,
      signed: false,
      thousandsSeparator: ' ',
      radix: '.',
      mapToRadix: [','],
      normalizeZeros: false
    })

    this.$module.submit(function () {
      self.$amount.val(parseFloat(maskedAmount.unmaskedValue))
    })

    this.$walletsSelector.dropdown('setItemHandler', function () {
      self.$wallets.val($(this).data('value')).trigger('change')
    })
    this.$walletsSelector.find('.b-dropdown__item_regular').trigger('click')
  }
}

$(function () {
  $('.js-partner_withdrawal').each(function () {
    new Module($(this))
  })
})
